import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router"

import HealthActions from "../../reducer"

export const useVampHistoricalDataMode = () => {
  const { pathname } = useLocation()
  const dispatch = useDispatch()
  const { isHistoricalDataMode, enrollmentData } = useSelector((state) => state.health)

  const isHistoricalDataModeBannerActive =
    isHistoricalDataMode && pathname.includes("/health/monitoring")

  const switchToHistoricalDataMode = () => {
    if (enrollmentData?.historical_data_available) {
      dispatch(HealthActions.healthSetProp("isHistoricalDataMode", true))
    }
  }

  return {
    isHistoricalDataMode,
    isHistoricalDataModeBannerActive,
    isHistoricalDataAvailable: enrollmentData?.historical_data_available,
    switchToHistoricalDataMode
  }
}
